import { useEffect, useState } from 'react';
import { IUseTablePaginationProps, TableData } from '../../../config/order-tracker-new-common/types';

/**
 * This custom hook provides pagination functionality for an array of data.
 * It takes props to define the data, items per page, and default page.
 *
 * @param props -
 *   - data: The array of data to be paginated.
 *   - itemsPerPage: The number of items to display per page.
 *   - defaultPage (optional): The initial page number to display (defaults to 1).
 *
 * @returns An object containing the following properties:
 *   - currentPageData: An array containing the data for the current page.
 *   - currentPage: The current page number.
 *   - handlePageChange: A function to handle page change events.
 */
const UseTablePagination = ({data, itemsPerPage = 10, defaultPage = 1}: IUseTablePaginationProps) => {
    const [currentPage, setCurrentPage] = useState<number>(defaultPage)
    const [currentPageData, setCurrentPageData] =  useState<TableData>([]);

    useEffect(() => {
        setCurrentPageData(getCurrentPageData(currentPage))
    }, [currentPage, data])

    const getCurrentPageData = (page: number): TableData => {
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, data.length);
        return data.slice(startIndex, endIndex);
    };

    const handlePageChange = (pageNumber: number) => {
        if (pageNumber < 1 || pageNumber > data.length) {
            return
        }
        setCurrentPage(pageNumber)
    }

    return {
        currentPageData,
        currentPage,
        handlePageChange
    }
}

export default UseTablePagination;
